export const get = (key) => {
  let item = localStorage.getItem(key);

  try {
    item = JSON.parse(item);
  } catch (err) {
  } finally {
    return item;
  }
};

export const set = (key, value) => {
  if (typeof value == "object") value = JSON.stringify(value);

  return localStorage.setItem(key, value);
};

export const remove = (key) => {
  return localStorage.removeItem(key);
};

export const removeAll = () => {
  return localStorage.clear();
};
